import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';


class CodigosPromocionaisAssociado extends React.Component {
    
    render() {
        return (
            <>
            <DashboardMenu />
            <Header titulo="Códigos Promocionais Associados" subtitulo="Cadastro" descricao="" />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        
    }
}

export default connect(mapStateToProps)(withRouter(CodigosPromocionaisAssociado));